import React from "react";
import { Button } from "@curves/ui-base";
import useDocumentApi from "@apis/useDocumentApi";
import { isFunction } from "@util/utils";

const DownloadCardAuthButton = ({ variant = "contained", onClick, ...rest }) => {
	const { getPaymentCreditCardPDFApi } = useDocumentApi();

	const handleDownload = async (e) => {
		await getPaymentCreditCardPDFApi();
		isFunction(onClick) && onClick(e);
	}

	return (
		<Button
			{...rest}
			variant={variant}
			onClick={handleDownload}
		>
			下載信用卡授權書
		</Button>
	);
};

export default DownloadCardAuthButton;